import { TGuildRosterClientState } from '../libs/store';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

// Action Types
export const GET_GUILD_ROSTER = 'GET_GUILD_ROSTER';

export type TGetGuildRosterAction = TAction<TGuildRosterClientState>;

// Action Creators
export function createActionGetGuildRoster(payload: TGuildRosterClientState): TGetGuildRosterAction {
  return {
    payload,
    type: GET_GUILD_ROSTER
  };
}
